import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./contexts/LanguageContext";
import WhatsAppFloatingButton from "./components/common/WhatsAppFloatingButton";
import Index from "./pages/Index";
import NotFound from "./pages/NotFound";
import Tours from "./pages/Tours";
import Activities from "./pages/Activities";
import WildlifeViewingDetail from "./pages/activities/WildlifeViewing";
import DesertExplorationDetail from "./pages/activities/DesertExploration";
import CulturalExperiencesDetail from "./pages/activities/CulturalExperiences";
import PhotographyToursDetail from "./pages/activities/PhotographyTours";
import OkavangoDeltaDetail from "./pages/activities/OkavangoDelta";
import VictoriaFallsDetail from "./pages/activities/VictoriaFalls";
import BigFiveSafariDetail from "./pages/tours/BigFiveSafari";
import NamibiaHighlightsDetail from "./pages/tours/NamibiaHighlights";
import WalvisbayExcursionDetail from "./pages/tours/WalvisbayExcursion";
import NamwildSafariDetail from "./pages/tours/NamwildSafari";
import NamibiaBotswanaVictoriaFallsDetail from "./pages/tours/NamibiaBotswanaVictoriaFalls";
import TourPage from "./pages/tours/TourPage";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import About from "./pages/About";
import OurGuides from "./pages/about/OurGuides";
import Philosophy from "./pages/about/Philosophy";
import Testimonials from "./pages/Testimonials";
import Contact from "./pages/Contact";
import Gallery from "./pages/Gallery";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import Sitemap from "./pages/Sitemap";
import CloudinaryDemo from "./pages/CloudinaryDemo";
import { HelmetProvider } from 'react-helmet-async';

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <HelmetProvider>
      <LanguageProvider>
        <TooltipProvider>
          <BrowserRouter>
            <Toaster />
            <Sonner />
            <WhatsAppFloatingButton />
            <Routes>
              <Route path="/" element={<Index />} />
              <Route path="/tours" element={<Tours />} />
              <Route path="/activities" element={<Activities />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
              <Route path="/about" element={<About />} />
              <Route path="/about/our-guides" element={<OurGuides />} />
              <Route path="/about/philosophy" element={<Philosophy />} />
              <Route path="/testimonials" element={<Testimonials />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/gallery" element={<Gallery />} />

              {/* Tour detail pages */}
              <Route path="/tours/big-five-safari" element={<BigFiveSafariDetail />} />
              <Route path="/tours/namibia-highlights" element={<NamibiaHighlightsDetail />} />
              <Route path="/tours/walvisbay-excursion" element={<WalvisbayExcursionDetail />} />
              <Route path="/tours/namwild-safari" element={<NamwildSafariDetail />} />
              <Route path="/tours/namibia-botswana-victoria-falls" element={<NamibiaBotswanaVictoriaFallsDetail />} />
              <Route path="/tours/:id" element={<TourPage />} />

              {/* Activities detail pages */}
              <Route path="/activities/wildlife-viewing" element={<WildlifeViewingDetail />} />
              <Route path="/activities/desert-exploration" element={<DesertExplorationDetail />} />
              <Route path="/activities/cultural-experiences" element={<CulturalExperiencesDetail />} />
              <Route path="/activities/photography-tours" element={<PhotographyToursDetail />} />
              <Route path="/activities/okavango-delta" element={<OkavangoDeltaDetail />} />
              <Route path="/activities/victoria-falls" element={<VictoriaFallsDetail />} />

              {/* Legal pages */}
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/terms-of-service" element={<TermsOfService />} />
              <Route path="/sitemap" element={<Sitemap />} />

              {/* Media upload */}
              <Route path="/media-upload" element={<CloudinaryDemo />} />

              {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </BrowserRouter>
        </TooltipProvider>
      </LanguageProvider>
    </HelmetProvider>
  </QueryClientProvider>
);

export default App;
